import { Component, Input } from '@angular/core';

import { AttendeeMenuLinkCms } from '~/cms/interfaces/attendee-menu.cms.interface';
@Component({
  selector: 'app-attendee-header-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class AttendeeHeaderNavigationComponent {
  @Input() public links: AttendeeMenuLinkCms[] = [];
}
